import React from 'react'

import {Services, Footer, Header, Offer} from './container'
import {Navbar} from './components'
import './App.scss'


const App = () => {
    return (
        <div className='app'>
            <Navbar/>
            <Header/>
            <Offer/>
            <Services/>
            <Footer/>
        </div>
    )
}

export default App